import getItemIdsFromConversations from 'owa-mail-list-store/lib/utils/getItemIdsFromConversations';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { actionNames } from 'owa-mail-store-actions';
import { setConversationInferenceClassificationService } from 'owa-mail-triage-action/lib/services/setConversationInferenceClassificationService';
import * as undoActions from 'owa-mail-undo';
import { action } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { getFocusedFilterForTable } from 'owa-mail-list-store';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyLogCustomDataLoggerDatapoint } from 'owa-analytics';
import { lazyBuildInferenceDatapoint } from 'owa-mail-inference-tracking';
import datapoints from '../datapoints';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
/**
 * move to focused/other action
 * @param conversationRowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param actionSource the source that initiated this action
 * @return the action response
 */
export default action('moveConversationToFocusedOrOtherAction', datapoints.moveConversationToFocusedOrOther)(function moveConversationToFocusedOrOther(conversationRowKeys, tableViewId, actionSource) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var focusedViewFilter = getFocusedFilterForTable(tableView);
    var isFocusedView = focusedViewFilter == 0 /* Focused */;
    var conversationIdStrings = getRowIdsFromRowKeys(conversationRowKeys, tableViewId);
    undoActions.clearLastUndoableAction();
    setConversationInferenceClassificationService(conversationIdStrings, isFocusedView ? 'Other' : 'Focused');
    if (isMailFeatureEnabled('tri-nonSubstrateInference')) {
        var itemIdsToLog_1 = getItemIdsFromConversations(conversationRowKeys, tableViewId);
        var activityTime_1 = new Date().toISOString();
        lazyBuildInferenceDatapoint.import().then(function (buildInferenceDatapoint) {
            lazyLogCustomDataLoggerDatapoint.importAndExecute(buildInferenceDatapoint(tableView.serverFolderId, focusedViewFilter, activityTime_1, isFocusedView ? "MarkAsOther" /* MarkAsOther */ : "MarkAsFocused" /* MarkAsFocused */, itemIdsToLog_1));
        });
    }
    // raise stitch to delete conversation from list view and reading pane
    // VSO 20053:Tombstone not working when moving conversation from focused to other
    raiseAction(actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, tableView);
});
//# sourceMappingURL=moveConversationToFocusedOrOther.js.map